export default {
  props: [
    {
      attr: 'phone',
      name: '手机号码'
    },
    {
      attr: 'realname',
      name: '孩子姓名'
    },
    {
      attr: 'orgName',
      name: '所属校区'
    },
    {
      attr: 'age',
      name: '孩子年龄'
    },
    {
      attr: 'school',
      name: '所在学校'
    },
    {
      attr: 'mothername',
      name: '家长姓名'
    },
    {
      attr: 'dataStatus',
      name: '数据状态',
      slot: 'dataStatus'
    },
    {
      attr: 'createtime',
      name: '录入时间',
      slot: 'createtime'
    },
    {
      attr: 'firstComm',
      name: '首次跟进时间',
      slot: 'firstComm',
      sortable: true
    },
    {
      attr: 'lastComm',
      name: '最近跟进时间',
      slot: 'lastComm',
      sortable: true
    },
    {
      attr: 'nextComm',
      name: '下次跟进时间',
      slot: 'nextComm',
      sortable: true
    },
    {
      attr: 'intention',
      name: '客户满意度',
      slot: 'intention'
    },
    {
      attr: 'isBindWeiXinDesc',
      name: '是否绑定微信公众号'
    },
    {
      attr: 'saler',
      name: '所属销售'
    },
    {
      attr: 'userName',
      name: '用户名'
    },
    {
      attr: 'reason',
      name: '无效原因',
      slot: 'reason'
    },
    {
      attr: 'orguserremark',
      name: '备注',
      slot: 'orguserremark'
    }
  ]
}
